export default {
    footnote: {
        padding: "8px",
    },
}
